import { object, string } from 'yup'

export const resetPasswordSchema = object().shape({
  email: string().required('Email is required').email('Incorrect email address')
})
